import axios from 'axios';

const SupportService = {
  async createTicket({ message }) {
    const response = await axios.post('/support/tickets', { message });
    return response.data;
  },
};

export default SupportService;

